import {Card} from 'platform/components';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, Section, WAREHOUSE_GRID_CODES} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface UpdateJobsLogProps extends RequiredTestIdProps {
  maximization?: EagGridMaximization;
}

export function UpdateJobsLog(props: UpdateJobsLogProps) {
  const {articleId} = useWarehouseParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {articleId}]),
    [articleId]
  );

  return (
    <Section isFullHeight>
      <Card title={i18n.t('entity.warehouse.labels.updateJobsLog')} isFullHeight>
        <div css={{height: '100%'}}>
          <DmsDataGrid
            maximization={props.maximization}
            gridCode={WAREHOUSE_GRID_CODES.articleUpdateJobsLog}
            queryModifier={queryModifier}
            data-testid={suffixTestId('updateJobsLog', props)}
          />
        </div>
      </Card>
    </Section>
  );
}
